export default __webpack_public_path__ + "static/media/voha-4.02b2a0ba.png";